module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/crud-fb60/crud-fb60.component.scss
// module id = ./src/app/pages/crud-fb60/crud-fb60.component.scss
// module chunks = main